import { render, staticRenderFns } from "./PagePhpUnit.vue?vue&type=template&id=249a18d1&"
import script from "./PagePhpUnit.vue?vue&type=script&lang=js&"
export * from "./PagePhpUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports